<template>
	<div>
		<sub-header bizCd="01"/>
		<div class="sub_visual sub01">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">기업·공공기관 온라인 위탁교육</div>
                    <div class="comment">회사와 개인의 미래를 위해 분야별 전문가 육성은 필수!<br>직무/직급 상관없이, 에듀윌이 준비한 다양한 컨텐츠를 확인해보세요.</div>
                    <div class="action pc_hidden">
                        <div><a href="//img.eduwill.net/resources/b2b/dev/에듀윌_기업·공공기관교육 서비스.pdf"
                        target="_blank" class="btn-1">B2B 브로슈어<i class="icon icon-arrow"></i></a></div>
                    </div>
                </div>
            </div>
        </div>
		<div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <div class="sub_tit">교육과정</div>
                    <div class="con">
                        <div class="txt">지금 가장 뜨겁게 부상 중인 기업별 선호과정을 확인하세요.</div>
                        <div class="course_list">
                            <div class="course_box">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/01-icon-property.png"
                                                alt="부동산" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-property@3x.png"
                                                alt="부동산" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">부동산</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list">
                                            <li>・ 공인중개사</li>
                                            <li>・ 실전 재테크</li>
                                            <li>・ 부동산 경매</li>
                                            <li>・ 토지,상가 컨설팅</li>
                                            <li>・ 부동산 마케팅</li>
                                            <li>・ 중개업 실무</li>
                                            <li>・ 감정평가사</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/01-icon-warning.png"
                                                alt="전기, 소방, 건축, 토목, 위험물" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-warning@3x.png"
                                                alt="전기, 소방, 건축, 토목, 위험물" class="mobile840hidden" />
                                        </div>
                                        <div class="txt line02">전기, 소방, 건축, 토목, 위험물</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list last_long">
                                            <li>・ 전기기사/기능사</li>
                                            <li>・ 건축기사</li>
                                            <li>・ 소방설비기사</li>
                                            <li>・ 토목기사</li>
                                            <li>・ 소방시설관리사</li>
                                            <li>・ 산업안전기사</li>
                                            <li>・ 위험물산업기사/기능사</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/01-icon-finance.png"
                                                alt="NCS" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-finance@3x.png"
                                                alt="NCS" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">재무
                                        </div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list">
                                            <li>・ 전산세무1,2급</li>
<!--                                            <li>・ 회계관리1,2급</li>-->
                                            <li>・ 전산회계1,2급</li>
                                            <li>・ ERP인사 1,2급</li>
                                            <li>・ 재경관리사</li>
                                            <li>・ ERP회계 1,2급</li>
<!--                                            <li>・ 세무사</li>-->
<!--                                            <li>・ 공인회계사</li>-->
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/01-icon-distribution.png"
                                                alt="물류, 유통, 무역" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-distribution@3x.png"
                                                alt="물류, 유통, 무역" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">물류, 유통, 무역</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list">
                                            <li>・ 물류관리사</li>
                                            <li>・ 유통관리사</li>
                                            <li>・ 국제무역사</li>
                                            <li>・ 무역영어</li>
                                            <li>・ ERP생산 1,2급</li>
                                            <li>・ ERP물류 1,2급</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/01-icon-guard.png"
                                                alt="시설, 경비, 은퇴설계" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-guard@3x.png"
                                                alt="시설, 경비, 은퇴설계" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">시설, 경비, 은퇴설계</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list last_long">
                                            <li>・ 주택관리사</li>
                                            <li>・ 조리기능사</li>
                                            <li>・ 제과제빵기능사</li>
                                            <li>・ 경비지도사</li>
                                            <li>・ 행정사</li>
                                            <li>・ 창업/재취업</li>
                                            <li>・ 도로교통사고감정사</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/01-icon-economy.png"
                                                alt="경제, 경영, NCS" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-economy@3x.png"
                                                alt="경제, 경영, NCS" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">경제, 경영, NCS</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ 매경TEST</li>
                                            <li>・ 한경TESAT</li>
                                            <li>・ 문제해결/자원관리 /의사소통/수리능력</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/01-icon-advice.png"
                                                alt="복지, 상담" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-advice@3x.png"
                                                alt="복지, 상담" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">복지, 상담</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ 사회복지사</li>
                                            <li>・ 직업상담사</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/01-icon-it.png"
                                                alt="IT" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-it@3x.png"
                                                alt="IT" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">IT</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list last_long">
                                            <li>・ 정보처리기사</li>
                                            <li>・ 워드프로세서</li>
                                            <li>・ 컴퓨터활용능력 1,2급</li>
                                            <li>・ 사무자동화산업기사</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/01-icon-license.png"
                                                alt="능력검정" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-license@3x.png"
                                                alt="능력검정" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">능력검정</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ 한국사능력검정</li>
                                            <li>・ 실용글쓰기</li>
                                            <li>・ KBS한국어능력시험</li>
                                            <li>・ TOPIK(한국어능력시험)</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="course_box">
                <div class="p_wrap">
                    <div class="co_tit">
                        <div class="icon">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/01-icon-safety.png" alt="산업안전보건" class="pc840hidden"/>
                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-safety@3x.png" alt="산업안전보건" class="mobile840hidden"/>
                        </div>
                        <div class="txt">산업안전보건</div>
                    </div>
                    <div class="co_contents">
                        <ul class="co_list wide">
                            <li>・ 관리감독자 안전보건</li>
                            <li>・ 근로자 안전보건</li>
                            <li>・ 특수형태종사자 안전보건</li>
                            <li>・ 위험성평가</li>
                        </ul>
                    </div>
                </div>
            </div> -->

                            <div class="course_box h230">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon_language.png"
                                                alt="어학" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon_language@3x.png"
                                                alt="어학" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">어학</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ TOEIC</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box h230">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-public.png"
                                                alt="HRD,전문직무" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-public@3x.png"
                                                alt="HRD,전문직무" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">HRD, 전문직무</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ 리더십 역량</li>
                                            <li>・ 소통역량 강좌</li>
                                            <li>・ 업무역량 향상 부문</li>
                                            <li>・ 팀워크/조직 활성화</li>
                                            <li>・ 은퇴자 창업</li>
                                            <li>・ 경영 시뮬레이션</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                          <div class="course_box h230">
                            <div class="p_wrap">
                              <div class="co_tit">
                                <div class="icon">
                                  <img src="//img.eduwill.net/resources/b2b/dev/images/icon_staff.png"
                                       alt="인사·노무" class="pc840hidden" />
                                  <img src="//img.eduwill.net/resources/b2b/dev/images/icon_staff@3x.png"
                                       alt="인사·노무" class="mobile840hidden" />
                                </div>
                                <div class="txt">인사·노무</div>
                              </div>
                              <div class="co_contents">
                                <ul class="co_list wide">
                                  <li>・ 공인노무사</li>
                                </ul>
                              </div>
                            </div>
                          </div>

                        </div>
                    </div>
                </div>

                <div class="sec">
                    <div class="sub_tit">교육담당자 <br class="m_hidden">후기</div>
                    <div class="con">
                        <div class="txt txt_line2">경험해 본 담당자가 만족했기에, 에듀윌 위탁교육</div>
                        <div class="section-review">
                            <div class="crown">
                                <ul>
                                    <li class="crown-1">
                                        <span>콘텐츠 만족도 <em>98%</em></span>
                                    </li>
                                    <li class="crown-2">
                                        <span>응대 만족도 <em>98%</em></span>
                                    </li>
                                    <li class="crown-3">
                                        <span>지인 추천 의향 <em>100%</em></span>
                                    </li>
                                </ul>
                                <div class="desc">*2021 에듀윌 온라인 위탁교육 진행 기업 대상 설문조사 결과</div>
                            </div>

                            <div class="item-slick item-slick-sub h346">
                                <div class="slick-inner">
                                    <div class="box">
                                        <div class="text-1">우수한 콘텐츠, 수준높은 교육 자료, 빠른 피드백에 감동했어요!</div>

                                        <div class="text-2">비대면 교육 관리에 대한 지식이 전혀 없어서 걱정했는데,<br>
                                            <span>에듀윌 담당자의 세심한 응대와 서비스</span>로 교육을 수월하게 진행할 수 있었습니다.</div>
                                        <div class="who">
                                            목포시 청년·일자리통합센터 교육 담당자
                                        </div>
                                        <div class="img img-1"><img
                                                src="//img.eduwill.net/resources/b2b/dev/images/roll-img-01.png">
                                        </div>
                                    </div>
                                </div>
                                <div class="slick-inner">
                                    <div class="box">
                                        <div class="text-1">교육 운영시 미처 신경쓰지 못했던 부분들까지 챙겨주십니다.</div>

                                        <div class="text-2"><span>교육 운영에 앞서 간과할 수 있는 부분 미리 선제 조치해 주시고 요구드리는
                                                사항에 대해
                                                최대한 반영해</span>주시려고 해서 감사했습니다. 그리고 일처리가 신속,정확하셔서 믿고 업무를
                                            진행할 수 있다는 점이 가장 큰 장점인 것 같습니다.</div>
                                        <div class="who">
                                            KOICA 개발협력 커리어센터 교육 담당자
                                        </div>
                                        <div class="img img-3"><img
                                                src="//img.eduwill.net/resources/b2b/dev/images/roll-img-02.png">
                                        </div>
                                    </div>
                                </div>
                                <div class="slick-inner">
                                    <div class="box">
                                        <div class="text-1">교육 자료와 프로그램 수준이 높아요, 역시 전문기관은 달라요!</div>

                                        <div class="text-2"><span>교육 자료 뿐만 아니라, 교육 구성 프로그램도 전반적으로 수준이 높아
                                                수강생들이
                                                아주 만족</span>했습니다. 확실히 전문기관은 다르네요! </div>
                                        <div class="who">
                                            셀트리온제약 교육 담당자
                                        </div>
                                        <div class="img img-3"><img
                                                src="//img.eduwill.net/resources/b2b/dev/images/roll-img-03.png">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <div class="sec">
                    <div class="sub_tit">고객사 전용 <br class="m_hidden">학습 사이트</div>
                    <div class="con">
                        <div class="txt txt_line2">고객사별 가장 적합한 형식의 전용 학습 사이트와 시스템을 제공합니다.<br>임직원은 전용 사이트에서
                            편리하게 수강하며 직무
                            전문성을 강화할 수 있습니다.</div>
                        <div class="course_slider">
                            <div class="swiper-container" id="loading-role">
                                <!-- Additional required wrapper -->
                                <div class="swiper-wrapper">
                                    <!-- Slides -->
                                    <div class="swiper-slide"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/img-01-01.png" alt="위탁교육">
                                    </div>
                                    <div class="swiper-slide"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/img-01-02.png" alt="위탁교육">
                                    </div>
                                    <div class="swiper-slide"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/img-01-03.png" alt="위탁교육">
                                    </div>
                                </div>
                                <!-- If we need pagination -->
                                <div class="swiper-pagination"></div>

                                <!-- If we need navigation buttons 
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
                -->
                            </div>
                            <div class="progress_wrapper">
                                <div class="swiper-counter">
                                    <span class="current">1</span> / <span class="total">0</span>
                                </div>
                                <div class="swiper-progress-bar">
                                    <div class="progress"></div>
                                    <div class="progress-sections"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="sec">
                    <div class="sub_tit">학습관리 <br class="m_hidden">페이지</div>
                    <div class="con">
                        <div class="txt txt_line2">실시간 학습 진행 상황을 확인할 수 있는 담당자 전용 학습관리 페이지를 제공합니다.<br>담당자는 해당
                            시스템을 통해
                            학습자별 진도 현황 및 전체적인 수강 현황 파악이 가능합니다.</div>
                        <div class="img_wrap">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/img-04.png" alt="학습관리페이지"
                                class="img_toggle_pc">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/img-04-mobile.png" alt="학습관리페이지"
                                class="img_toggle_mobile">
                        </div>
                    </div>
                </div>

                <div class="sec">
                    <div class="sub_tit">전문 학습지원<br class="m_hidden">센터 운영</div>
                    <div class="con">
                        <div class="txt txt_line2">위탁교육 학습자를 위한 전용 학습지원센터를 운영합니다.<br>전문 상담을 통해 수강문의부터 학습안내까지
                            빠르고 정확한 답변을
                            받을 수 있습니다.</div>
                        <div class="img_wrap">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/img-05.png" alt="학습관리페이지"
                                class="img_toggle_pc">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/img-05-mobile.png" alt="학습관리페이지"
                                class="img_toggle_mobile">
                        </div>
                    </div>
                </div>

                <div class="sec">
                    <div class="clearfix">
                        <div class="sub_tit">온라인 위탁교육 Flow</div>
                    </div>
                    <div class="con_wide">

                        <!-- flow PC -->
                        <div class="flow_common flow_m_hidden">
                            <div class="f_wrap">
                                <div class="step01 aos-item" data-aos="fade-right" data-aos-delay="300"
                                    data-aos-offset="0"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img-flow-01-01.png" alt="고객사" />
                                </div>
                                <div class="step02 flow_line aos-item" data-aos="fade-right" data-aos-delay="450"
                                    data-aos-offset="0">
                                    <div class="text">교육비 지원,위탁</div>
                                    <div class="arrow_right"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5.png" alt="flow화살표" />
                                    </div>
                                    <div class="arrow_left"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5-copy.png"
                                            alt="flow화살표" /></div>
                                    <div class="text">시스템 지원, 운영보고</div>
                                </div>
                                <div class="step03 aos-item" data-aos="fade-right" data-aos-delay="600"
                                    data-aos-offset="0">
                                    <div class="step_edu">
                                        <div class="step_edu_con">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/logo_on.png" />
                                            <p>에듀윌</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="step04 flow_line aos-item" data-aos="fade-right" data-aos-delay="750"
                                    data-aos-offset="0">
                                    <div class="text">강의, 학습지원</div>
                                    <div class="arrow_right"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5.png" alt="flow화살표" />
                                    </div>
                                    <div class="arrow_left"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5-copy.png"
                                            alt="flow화살표" /></div>
                                    <div class="text">학습질문</div>
                                </div>
                                <div class="step05 aos-item" data-aos="fade-right" data-aos-delay="900"
                                    data-aos-offset="0"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img-flow-01-03.png" alt="임직원" />
                                </div>
                            </div>
                        </div>

                        <!-- flow Mobile  -->
                        <div class="flow_common flow_pc_hidden">
                            <div class="f_wrap">
                                <div class="wide">
                                    <div class="step_edu aos-item" data-aos="fade-right" data-aos-delay="450"
                                        data-aos-offset="0">
                                        <div class="step_edu_con">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/logo_on.png" />
                                            <p>에듀윌</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="stepper">
                                    <div class="img_left aos-item" data-aos="fade-right" data-aos-delay="300"
                                        data-aos-offset="0">
                                        <div class="flow_mo_left">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/flow01_1_left.png" />
                                        </div>
                                    </div>
                                    <div class="img_right aos-item" data-aos="fade-right" data-aos-delay="600"
                                        data-aos-offset="0">
                                        <div class="flow_mo_right">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/flow01_1_right.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="sub_partner">
                <div class="container">
                    <div class="title_line">
                        <div class="pa_tit">Partner</div>
                        <div class="text">에듀윌과 함께하는 기업·공공기관 파트너사입니다.</div>
                    </div>
                    <ul class="pa_slider_scroll">
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_01_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_01.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_02.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_03.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_04.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_02_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_05.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_06.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_07.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_08.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_09.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_10.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_11.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_12.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_13.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_14.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_15.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_16.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_17.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_18.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_03_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_19.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_20.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_21.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_04_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_22.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_23.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_24.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_25.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_26.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_27.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_28.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_29.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_30.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_05_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_06_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_07_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_08_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_09_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_10_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_01.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_02.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_03.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_04.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_05.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_06.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_07.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_08.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_09.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_10.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_11.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_12.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_11_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_12_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_13.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_14.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_15.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_16.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_13_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_14_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_17.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_18.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_19.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_20.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_15_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_21.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_22.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_23.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_24.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_25.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_26.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_17_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_16_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_18_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_27.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_28.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_29.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_30.png" /></li>
                    </ul>
                </div>
            </div>
        </div>
    <div class="float_counsel m_hidden">
        <div class="group-wrap">
            <div class="group">
                <div class="text">에듀윌 기업·공공기관<br>교육 서비스</div>
                <div class="button"><a href="//img.eduwill.net/resources/b2b/dev/에듀윌_기업·공공기관교육 서비스.pdf"
                        target="_blank">브로슈어 다운로드</a></div>
                <div class="ico-hand"></div>
            </div>
            <div class="group">
                <div class="text">에듀윌과 함께<br>변화를 시작하세요.</div>
                <div class="button"><a href="javascript:;" @click="show_counsel('01')">맞춤상담신청</a></div>
                <div class="ico-hand"></div>
            </div>
        </div>
    </div>
    <div class="float_counsel_mobile pc_hidden">
        <a class="circle_counsel" @click="showCounsel('01')">맞춤<br>상담</a>
    </div>
	</div>
</template>

<script>
import SubHeader from "@/layouts/SubHeader";
import eventBus from "@/eventBus/event-bus";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
		showCounsel(v) {
			eventBus.$emit("show-counsel", v);
		},
		closeCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup().close();
		},
		showCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup();
		}
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>

<style scoped>

</style>
